import react from "react";


const Tabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
  <div className="w-full mb-4 flex justify-start">
              <div className="inline-flex bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => setActiveTab(tab.value)}
          className={`relative px-5 py-2 lg:px-8 lg:py-3 text-xs lg:text-lg font-semibold focus:outline-none transition-all duration-200
            ${activeTab === tab.value
              ? 'card-head text-white shadow-md scale-105'
              : 'text-gray-600 bg-transparent hover:bg-blue-50'}
            ${tab.value === tabs[0].value ? 'rounded-l-2xl' : ''}
            ${tab.value === tabs[tabs.length-1].value ? 'rounded-r-2xl' : ''}
          `}
        >
          {tab.label}
          {activeTab === tab.value && (
            <span className="absolute left-4 right-4 -bottom-1 h-1 rounded bg-blue-400 transition-all duration-200"></span>
          )}
        </button>
      ))}
              </div>
            </div> 
            );
}

export default Tabs;